import { useContext } from "react";
import secondaryComponents from "../..";
import { useDeleteInterwitchAccount } from "../../../../hooks/api/mutations/useTerminals";
import { ToastContext } from "../../../../hooks/context";

export const DeleteBusinessAccountTable = ({
  businessAccountDetails = null,
  closeModal = () => {},
}) => {
  const triggerToast = useContext(ToastContext);
  const { mutate: deleteAccountMutate, isLoading } =
    useDeleteInterwitchAccount();
  const deleteAccount = () => {
    deleteAccountMutate(
      { id: businessAccountDetails?.id },
      {
        onSuccess: () => {
          triggerToast("Business account deletion successful", "success");
          closeModal();
        },
      },
    );
  };

  return (
    <secondaryComponents.DeletePrompt
      title="Are you sure you want to delete this account"
      onClose={closeModal}
      onSubmit={deleteAccount}
      isSubmiting={isLoading}
    >
      <h5>
        Merchant Name:{" "}
        <span className="gray--text font-weight-normal">
          {businessAccountDetails?.merchant_name}
        </span>
      </h5>
    </secondaryComponents.DeletePrompt>
  );
};
